export function useShadow(context, render, color) {
  context.shadowColor = color || 'rgba(0, 0, 0, 0.2)';
  context.shadowBlur = 8;
  context.shadowOffsetY = 0;
  context.shadowOffsetX = 0;

  render();
  // 清除阴影效果
  context.shadowColor = 'transparent';
  context.shadowBlur = 0;
  context.shadowOffsetY = 0;
  context.shadowOffsetY = 0;
}

export function renderInteractiveGroupBorder(renderContext, node) {
  const { context } = renderContext;
  const { scale } = renderContext.providers;
  const region = renderContext.api
    .getNodeRegion(node)
    .transform(scale.scale, scale.translateX, scale.translateY);

  useShadow(
    context,
    () => {
      context.strokeStyle = 'rgba(255, 255, 255, 1)'; // Light white color with 80% opacity
      context.lineWidth = 4;
      context.setLineDash([8, 8]); // Set dashed line pattern (5px dash, 5px gap)
      context.lineCap = 'round'; // Add rounded line caps

      context.beginPath();
      context.moveTo(region.topLeft.x, region.topLeft.y);
      context.lineTo(region.topRight.x, region.topRight.y);
      context.lineTo(region.bottomRight.x, region.bottomRight.y);
      context.lineTo(region.bottomLeft.x, region.bottomLeft.y);
      context.lineTo(region.topLeft.x, region.topLeft.y);
      context.closePath();
      context.stroke();

      context.setLineDash([]); // Reset dash pattern to solid line
      context.lineCap = ''; // Reset line cap to default
      context.strokeStyle = '';
    },
    'rgba(0, 0, 0, 0.4)'
  );
}

export function renderEdgeHandler(context, area, isActive) {
  const cornerRadius = 6;
  const isFrameEdge = area && area.style === 'frameEdge';
  if (isFrameEdge) {
    context.fillStyle = isActive ? 'rgba(0,0,0,0.6)' : 'rgba(0,0,0,0.18)';
    context.strokeStyle = 'transparent';
    context.lineWidth = 0;
  } else {
    context.fillStyle = isActive ? '#8b3eff' : 'white';
    context.strokeStyle = '#a6a6a6';
    context.lineWidth = 1;
  }

  // Save current context state
  context.save();

  // Move origin to center of area
  context.translate(area.center.x, area.center.y);

  // Apply rotation
  context.rotate((area.angle * Math.PI) / 180);
  const newArea = area.rotate(-area.angle);
  const rect = newArea.rect;
  // Calculate rotated coordinates relative to center
  const halfWidth = rect.w / 2;
  const halfHeight = rect.h / 2;

  // Draw rounded rectangle
  context.beginPath();
  context.moveTo(-halfWidth + cornerRadius, -halfHeight);
  context.arcTo(halfWidth, -halfHeight, halfWidth, -halfHeight + cornerRadius, cornerRadius);
  context.arcTo(halfWidth, halfHeight, halfWidth - cornerRadius, halfHeight, cornerRadius);
  context.arcTo(-halfWidth, halfHeight, -halfWidth, halfHeight - cornerRadius, cornerRadius);
  context.arcTo(-halfWidth, -halfHeight, -halfWidth + cornerRadius, -halfHeight, cornerRadius);
  context.closePath();

  if (isFrameEdge) {
    // cleaner solid look for frame handles
    context.fill();
  } else {
    useShadow(context, () => {
      context.fill();
    });
    context.stroke();
  }

  // Restore context state
  context.restore();
}

export function renderPointHandler(context, area, isActive) {
  context.strokeStyle = '#a6a6a6';
  context.lineWidth = 1;
  context.fillStyle = isActive ? '#8b3eff' : 'white';
  context.beginPath();

  const center = area.center;

  useShadow(context, () => {
    context.arc(center.x, center.y, area.w / 2, 0, 2 * Math.PI);
    context.fill();
  });

  context.stroke();
}

// 旋转手柄渲染ß
export function renderRotateHandler(context, area, isActive) {
  const center = area.center;
  const radius = typeof area.visualRadius === 'number' ? area.visualRadius : area.w / 2;

  // 外圈：简洁的圆环设计
  context.fillStyle = isActive ? '#8b3eff' : '#ffffff';
  context.strokeStyle = isActive ? '#8b3eff' : '#e2e8f0';
  context.lineWidth = 1;

  // 添加微妙阴影提升层次感
  context.shadowColor = 'rgba(0, 0, 0, 0.08)';
  context.shadowBlur = 4;
  context.shadowOffsetY = 2;

  context.beginPath();
  useShadow(context, () => {
    context.arc(center.x, center.y, radius, 0, 2 * Math.PI);
    context.fill();
  });
  context.stroke();

  // 清除阴影
  context.shadowColor = 'transparent';
  context.shadowBlur = 0;
  context.shadowOffsetY = 0;

  // 内部旋转图标：基于实际区域尺寸动态缩放
  const iconRadius = radius * 0.7;
  const iconSize = iconRadius * 2; // 图标的整体尺寸
  const scale = iconSize / 24; // 基于实际图标尺寸缩放，而不是固定24

  context.strokeStyle = isActive ? '#fff' : '#64748b';
  context.lineWidth = Math.max(2 * scale, 1); // 确保线条至少1像素宽
  context.lineCap = 'round';
  context.lineJoin = 'round';

  // 箭头曲线半径，基于实际缩放比例动态计算
  const arcRadius = iconRadius * 0.75; // 将固定半径改为基于图标半径的比例

  // 上半部分弧形，缩短弧形避免与箭头相交
  context.beginPath();
  // 绘制上半部分的弧形，使用动态计算的弧形半径
  const startAngle1 = Math.atan2(0, 7 * scale); // 从(19,12)开始
  const endAngle1 = Math.atan2(-4 * scale, -9 * scale); // 到(3,8)附近但不完全到达
  context.arc(center.x, center.y, arcRadius, startAngle1, endAngle1, true);

  context.stroke();

  // 上方箭头: M3 3v5h5 (垂直线和水平线形成L形箭头)
  context.beginPath();
  const arrowBaseX1 = center.x + (3 - 12) * scale;
  const arrowBaseY1 = center.y + (3 - 12) * scale;
  context.moveTo(arrowBaseX1, arrowBaseY1);
  context.lineTo(arrowBaseX1, arrowBaseY1 + 5 * scale); // 向下5个单位
  context.lineTo(arrowBaseX1 + 5 * scale, arrowBaseY1 + 5 * scale); // 向右5个单位
  context.stroke();

  // 下半部分弧形，缩短弧形避免与箭头相交
  context.beginPath();
  // 绘制下半部分的弧形，使用动态计算的弧形半径
  const startAngle2 = Math.atan2(0, -7 * scale); // 从(5,12)开始
  const endAngle2 = Math.atan2(4 * scale, 7 * scale); // 到(19,16)附近但不完全到达
  context.arc(center.x, center.y, arcRadius, startAngle2, endAngle2, true);

  context.stroke();

  // 下方箭头: M16 16h5v5 (水平线和垂直线形成L形箭头)
  context.beginPath();
  const arrowBaseX2 = center.x + (16 - 12) * scale;
  const arrowBaseY2 = center.y + (16 - 12) * scale;
  context.moveTo(arrowBaseX2, arrowBaseY2);
  context.lineTo(arrowBaseX2 + 5 * scale, arrowBaseY2); // 向右5个单位
  context.lineTo(arrowBaseX2 + 5 * scale, arrowBaseY2 + 5 * scale); // 向下5个单位
  context.stroke();
}

// Line节点控制点的渲染 - Refined to resemble Figma anchors
export function renderLinePointHandler(context, area, isActive) {
  const center = area.center;
  const radius = area.w / 2;

  context.beginPath();
  context.arc(center.x, center.y, radius, 0, 2 * Math.PI);

  // Figma style: White fill, 1px stroke (grey) for unselected. Blue fill for selected.
  if (isActive) {
    context.fillStyle = '#8b3eff';
    context.strokeStyle = '#ffffff'; // Contrast ring
    context.lineWidth = 1.5;
  } else {
    context.fillStyle = '#ffffff';
    context.strokeStyle = '#a6a6a6'; // Neutral stroke
    context.lineWidth = 1;
  }

  useShadow(context, () => {
    context.fill();
  });
  context.stroke();
}

// Path Anchor (Square) Renderer - NEW
export function renderPathAnchorHandler(context, area, isActive) {
  const center = area.center;
  // Visual size should be smaller than hit area (area.w is ~24)
  // Let's aim for ~8-10px visual size
  const visualSize = 10;
  const half = visualSize / 2;

  // Square shape for Anchors
  context.beginPath();
  context.rect(center.x - half, center.y - half, visualSize, visualSize);

  if (isActive) {
    context.fillStyle = '#8b3eff';
    context.strokeStyle = '#ffffff';
    context.lineWidth = 1;
  } else {
    context.fillStyle = '#ffffff';
    context.strokeStyle = '#a6a6a6';
    context.lineWidth = 1;
  }

  useShadow(
    context,
    () => {
      context.fill();
    },
    'rgba(0,0,0,0.15)'
  );
  context.stroke();
}

// 新增：渲染线段中点控制点
export function renderLineMidPointHandler(context, area, isActive) {
  // If not active (hovered), we might want to hide it or make it very subtle
  if (!isActive) {
    return;
  }

  const center = area.center;
  const radius = 7; // Increased visual radius for better visibility

  context.beginPath();
  context.arc(center.x, center.y, radius, 0, 2 * Math.PI);

  context.fillStyle = isActive ? '#8b3eff' : '#ffffff';
  context.strokeStyle = isActive ? '#ffffff' : '#e2e8f0';
  context.lineWidth = 1;

  if (isActive) {
    useShadow(context, () => {
      context.fill();
    });
  } else {
    context.fill();
  }
  context.stroke();
}

// 新增：渲染 Path 曲线控制点（Figma style: Circle + Line）
export function renderPathControlHandler(context, area, isActive) {
  const center = area.center;
  // Visual radius ~4-5px
  const radius = 4.5;

  // 1. Draw Connection Line
  if (area.anchorPoint) {
    context.save();
    context.beginPath();
    context.moveTo(area.anchorPoint.x, area.anchorPoint.y);
    context.lineTo(center.x, center.y);

    context.strokeStyle = '#8b3eff'; // Theme color for handle lines
    context.lineWidth = 1;
    context.stroke();
    context.restore();
  }

  // 2. Draw Handle Knob (Circle)
  context.beginPath();
  context.arc(center.x, center.y, radius, 0, 2 * Math.PI);

  // Style
  context.fillStyle = isActive ? '#8b3eff' : '#ffffff';
  context.strokeStyle = '#8b3eff';
  context.lineWidth = 1;

  useShadow(
    context,
    () => {
      context.fill();
    },
    'rgba(0,0,0,0.1)'
  );

  context.stroke();
}
